import { render } from "./WidgetModalBoostrap.vue?vue&type=template&id=180698e2"
import script from "./WidgetModalBoostrap.vue?vue&type=script&lang=js"
export * from "./WidgetModalBoostrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__